import type { AgencyRecentlyUsedItem } from '@saaga/shared/interfaces/agency-recently-used.interface'
import { BotIcon } from 'lucide-react'

import type { GlobalSearchResultGroup, GlobalSearchResultItem } from './global-search.interface'

const MAX_RECENT_AGENCIES = 3

const transformRecentAgency = (agency: AgencyRecentlyUsedItem): GlobalSearchResultItem => ({
  id: agency.slug,
  title: agency.presentation_name,
  description: agency.presentation_description_short ?? undefined,
  imageUrl: agency.presentation_image_path ?? null,
  icon: BotIcon,
})

/**
 * Builds the default groups shown when the search palette opens with no query.
 * Shows recent agencies and static navigation items.
 */
export const buildDefaultGroups = (
  recentAgencyList: AgencyRecentlyUsedItem[],
  navigationItemList: GlobalSearchResultItem[]
): GlobalSearchResultGroup[] => {
  const groupList: GlobalSearchResultGroup[] = []

  const recentItemList = recentAgencyList.slice(0, MAX_RECENT_AGENCIES).map(transformRecentAgency)

  if (recentItemList.length > 0) {
    groupList.push({
      type: 'recent_agency',
      label: 'Recent Agencies',
      itemList: recentItemList,
    })
  }

  if (navigationItemList.length > 0) {
    groupList.push({
      type: 'navigation',
      label: 'Pages',
      itemList: navigationItemList,
    })
  }

  return groupList
}
